import defaultMessages from "ra-language-english";
import polyglotI18nProvider from "ra-i18n-polyglot";

/**
 * Overrides for react-admin's auto-generated resource label (`useGetResourceLabel`,
 * `resources.<resource>.name`) — needed only by pseudo-resources whose raw
 * name isn't a real singular noun `inflection.pluralize`/`humanize` can
 * handle cleanly. A `ResourceTable`-level `resource` override that isn't a
 * registered `<Resource name>` (e.g. `bookings-dashboard-internal`'s
 * `events-unconfirmed`/`events-escalated` tabs) has no `options.label` to
 * fall back on, so it hits this naive default: `inflect('events-unconfirmed',
 * 2)` -> `"events-unconfirmeds"` -> `humanize` -> "Events-unconfirmeds"
 * (ticket: "Events-escalateds, really? May be you ment Escalated Events?").
 */
const RESOURCE_NAME_OVERRIDES = {
  "events-unconfirmed": {
    name: "Unconfirmed Events",
  },
  "events-escalated": {
    name: "Escalated Events",
  },
};

export const i18nProvider = polyglotI18nProvider(
  () => ({ ...defaultMessages, resources: RESOURCE_NAME_OVERRIDES }),
  "en",
  [{ name: "en", value: "English" }],
  { allowMissing: true },
);
